module.exports = __webpack_public_path__ + "static/img/avatar1.ba8d496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar/avatar1.png
// module id = bz5X
// module chunks = 6